import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { getUserLandingPath } from "const";
import { CustomerSelector } from "redux/selector/customer-selector";

/**
 * คืน goHome() เพื่อไปหน้าหลักตาม isPwmUser — ภายในใช้ getUserLandingPath
 */
export default function useNavigateUserLanding() {
  const dispatch = useDispatch();
  const isPwmUser = useSelector(CustomerSelector.isPwmUser);

  const goHome = useCallback(() => {
    dispatch(push(getUserLandingPath(isPwmUser)));
  }, [dispatch, isPwmUser]);

  return { goHome };
}
